import React from "react";
import { ILongerGameStatisticsProps } from "@/types/LongerStatisticsTypes";
import { processMultilineStatistics, beadJSX } from "@/modules/statistics";
import { isPortrait } from "@/modules/commonMobile";

interface IProps extends Omit<ILongerGameStatisticsProps, "history"> {
	history: IHiLoRoadmapItemType[];
}

interface IHiLoRoadmapItemType {
	// dragon: string;
	// tiger: string;
	angka: string;
	// idnomor: number;
	// gamekey: string; // "2",
	periode: number; // 8
	
	//Done in runtime
	// win: string;
}

export default class M34 extends React.Component<IProps> {
    statisticsArray = [];

    filtrate(history: IHiLoRoadmapItemType[]) {
        let hi = 0, lo = 0, seven = 0, odd = 0, even = 0;

        history.forEach((item) => {
            const angka = Number(item.angka);

            if (angka < 7)
                lo++;
            else if (angka > 7)
                hi++;
            else seven++;

            if (!(angka % 2))
                even++;
            else odd++;
        });

        const statisticsCells = {
            top: [
                beadJSX("circle", "blue", "Hi"),
                beadJSX("circle", "red", "Lo"),
                beadJSX("circle", "green", "7"),
                
                beadJSX("circle-hollow", "red", "E"),
				beadJSX("circle-hollow", "blue", "O"),
            ],
            bottom: [
                hi, lo, seven, even, odd
            ].map((item, idx) => <div key={"m34_" + idx}>{item}</div>),
        };

        const cellsPerLine = 5;
		this.statisticsArray = [];

		processMultilineStatistics(this.statisticsArray, statisticsCells, cellsPerLine, isPortrait(),
			"m23");
    }

    render() {
        if (!this.props.history)
            return null;

        this.filtrate(this.props.history);
        
        const statisticsTable = (
            <table><tbody>
                { this.statisticsArray }
            </tbody></table>
        );
        
        return (
            <div className={"game-statistics m34" +
                    (isPortrait() ? " multiline" : "") +
                    (this.props.baccaratDarkMode ? " dark" : "")
                }>

                {statisticsTable}
            </div>
        );
    }
}